<script setup>
import i18n from "@/i18n"
import { ref, reactive, onMounted, nextTick, onUnmounted } from "vue";
import { showMessage } from "@/utils/hooks/message"
import completeSvg from "@/assets/images/login/complete.svg"
// import Swal from "sweetalert2";
import { update_username, } from "@/service/index"
import { useRoute, useRouter } from "vue-router";
import { getLangValue } from "@/utils/common"; //获取后端语言
const route = useRoute();
const router = useRouter();
const FILINGNUMBER = window.appConfig.FILINGNUMBER || ''
const FILINGURL = window.appConfig.FILINGURL || ''
const chineseClick = () => {
    const language = "ch";
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
}
const englishClick = () => {
    const language = "en";
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
}
const showIndex = ref(0)  // 0 验证人机页面 1 提示页面  2 重置密码页面
const formData = reactive({
    title: getLangValue('login.title3'),
    company: '',
    email: route.query.email || '',
    password: '',
    confirmPassword: '',
    confimInfo: false,
    remember: false,
})
const dragData = reactive({
    beginClientX: 0,           /*距离屏幕左端距离*/
    mouseMoveStata: false,     /*触发拖动状态  判断*/
    maxwidth: '',               /*拖动最大宽度，依据滑块宽度算出来的*/
    confirmSuccess: false /*验证成功判断*/,
    message: getLangValue('login.message2'),
    message1: getLangValue('login.message4'),
})
const dragDiv = ref(null)
const moveDiv = ref(null)
const isCheckForm = ref(false)
/**注册部分 */
// const checkPassword = () => {
//     // 需要验证密码复杂程度
//     if (formData.password) {
//         // 至少8个字符，包含至少一个大写字母、小写字母、数字和特殊字符
//         const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
//         if (!regex.test(formData.password)) {
//             return false;
//         }
//     }
//     return true;
// }

const checkEmail = () => {
    if (formData.email) {
        // 邮箱格式
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(formData.email)) {
            return false;
        }
    }
    return true;
}
const register = async () => {
    isCheckForm.value = true;
    // 验证表单信息`
    if (!formData.email || !formData.password || !formData.confirmPassword) {
        showMessage('danger', getLangValue('base.requiredinformation'))
        return false
    }
    if (formData.confirmPassword !== formData.password) {
        showMessage('danger', getLangValue('login.message8'))
        return false
    }
    // 邮箱验证
    const res_email = checkEmail();
    if (!res_email) {
        showMessage('danger', getLangValue('login.message10'))
        return false
    }
    // // 密码复杂度验证
    // const res = checkPassword();
    // if (!res) {
    //     showMessage('danger', getLangValue('login.message7'))
    //     return false
    // }
    // 条款验证
    // if (!formData.confimInfo) {
    //     showMessage('danger', getLangValue('login.message9'))
    //     return false
    // }
    let params = {
        username: formData.email,
        password: formData.password,
        vcode: route.query.vcode
    }
    //注册
    const resp = await update_username(params)
    if (resp) {
        if (resp.code == 0) {
            showMessage('success', getLangValue('login.message15'))
            // showIndex.value = 1
            // formData.title = getLangValue('login.login')
            setTimeout(() => {
                router.push({ path: '/login' })
            }, 2000)
        } else {
            showMessage('danger', resp.message)
        }
    }
}

// const showInfo = () => {
//     Swal.fire({
//         width: '1092px',
//         html: `<div>
//             <div class='my-title my-2' style='font-size:16px; font-weight:bold'>使用条款</div>
//             <div style='text-align:left;line-height:22px'>
//                 <div style='font-size:14px'>欢迎使用本系统！请在使用本系统之前仔细阅读以下使用条款。访问和使用本系统即表示您已阅读、理解并同意遵守以下条款和条件。如果您不同意这些条款，请勿使用本系统。</div>
//                 <div style='font-size:14px'>1. 接受条款</div>
//                 <div style='font-size:14px'>本系统的使用受这些使用条款（以下简称“条款”）的约束。我们保留随时修改这些条款的权利，恕不另行通知。您有责任定期查看这些条款的最新版本。您继续使用本系统将被视为接受修改后的条款。</div>
//                 <div style='font-size:14px'>2. 使用权限</div>
//                 <div style='font-size:14px'>您被授予有限的、非排他的、不可转让的权限，访问和使用本系统及其内容仅用于个人和非商业用途。您不得复制、修改、发布、出售、租赁、分发或创作本系统内容的衍生作品。</div>
//                 <div style='font-size:14px'>3. 用户账户</div>
//                 <div style='font-size:14px'>为了访问某些功能，您可能需要创建用户账户。您承诺提供准确、完整的信息，并保持账户信息的更新。您对账户的所有活动负责，应确保您的账户密码安全。若发现账户存在未经授权的使用情况，请立即通知我们。</div>
//                 <div style='font-size:14px'>4. 用户行为</div>
//                 <div style='font-size:14px'>在使用本系统时，您同意不从事以下行为：</div>
//                 <div style='font-size:14px'>
//                     <ul style='padding-left:20px'>
//                         <li style='list-style:disc' class='mx-2'>发布或传播任何非法、有害、威胁、辱骂、骚扰、诽谤、粗俗、淫秽、侵犯他人隐私、憎恨或种族歧视的内容；</li>
//                         <li style='list-style:disc' class='mx-2'>违反任何适用的法律法规；</li>
//                         <li style='list-style:disc' class='mx-2'>未经授权访问或尝试访问本系统的任何部分；</li>
//                         <li style='list-style:disc' class='mx-2'>干扰或破坏本系统或连接至本系统的服务器和网络的运行。</li>
//                     </ul>
//                 </div>
//                 <div style='font-size:14px'>5. 知识产权</div>
//                 <div style='font-size:14px'>本系统及其所有内容（包括但不限于文字、图像、图形、标志、声音、视频和软件）均受知识产权法保护，属于本系统或其许可方的财产。未经明确许可，不得以任何形式使用这些内容。</div>
//                 <div style='font-size:14px'>6. 免责声明</div>
//                 <div style='font-size:14px'>本系统按“原样”提供，不保证其内容的准确性、完整性、可靠性和适用性。在法律允许的最大范围内，我们不承担因使用本系统或无法使用本系统而引起的任何损害赔偿责任。</div>
//                 <div style='font-size:14px'>7. 终止</div>
//                 <div style='font-size:14px'>我们有权在任何时候，因任何原因（包括但不限于违反这些条款），终止或限制您对本系统的访问，而无需事先通知。</div>
//                 <div style='font-size:14px'>8. 适用法律</div>
//                 <div style='font-size:14px'>这些条款应受[适用国家/地区]的法律管辖，不考虑其法律冲突原则。您同意任何因这些条款引起或与之相关的争议，均应提交[适用国家/地区]法院解决。</div>
//                 <div style='font-size:14px'>9. 联系方式</div>
//                 <div style='font-size:14px'>如有任何问题或疑虑，请通过以下联系方式与我们联系：[电子邮件地址]，[联系电话]。</div>
//             </div>
//         </div>`,
//         showConfirmButton: true,
//         confirmButtonText: getLangValue('login.agreeAndContinue'),
//         confirmButtonColor: '#0AB39C',
//         // confirmButtonTextColor: '#fff',
//     });
// }

const goLogin = () => {
    router.push({ path: '/login' })
}

const switchPassword = (typeIndex = 0) => {
    if (typeIndex == 0) {
        let type = document.getElementById('password-input').getAttribute('type');
        document.getElementById('password-input').setAttribute('type', type == 'text' ? 'password' : 'text')
    } else {
        // console.log(type);
        let type = document.getElementById('password-input' + typeIndex).getAttribute('type');
        document.getElementById('password-input' + typeIndex).setAttribute('type', type == 'text' ? 'password' : 'text')
    }
}


const switchCotent = async () => {
    // 判断验证是否通过
    isCheckForm.value = true;
    if (!formData.email) {
        showMessage('danger', getLangValue('base.requiredinformation'))
        return false
    }
    // 邮箱验证
    const res_email = checkEmail();
    if (!res_email) {
        showMessage('danger', getLangValue('login.message10'))
        return false
    }
    // 判断拖动验证
    if (!dragData.confirmSuccess) {
        showMessage('danger', getLangValue('login.message11'))
        return false
    }
    showIndex.value = 2
    isCheckForm.value = false
}


/**
* 登录部分
*/

/**
 * 重置密码部分
 */

// const forgetPassword = () => {
//     showIndex.value = 1;
//     formData.type = 1;
//     formData.title = getLangValue('login.title2')
// }


/**
* 重置密码部分
*/

/** 
 * 拖动验证部分
 */

const initBar = () => {
    nextTick(() => {
        // 根据滑块宽度计算可拖动最大宽度
        dragData.maxwidth = dragDiv.value.clientWidth - moveDiv.value.clientWidth;
        // 监听手指的触摸事件
        document.addEventListener('mousemove', mouseMoveFn);
        // 监听手指离开事件
        document.addEventListener('mouseup', moseUpFn)
        document.getElementById('moveBg').style.width ='0px';
    })
}
const mousedownFn = (e) => {
    if (!dragData.confirmSuccess) {
        e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
        dragData.mouseMoveStata = true;
        dragData.beginClientX = e.clientX;

    }
}
const mouseMoveFn = (e) => {
    if (dragData.mouseMoveStata) {
        let width = e.clientX - dragData.beginClientX;
        if (width > 0 && width <= dragData.maxwidth) {
            document.getElementsByClassName('moveDiv')[0].style.left = width + 'px';
            document.getElementById('moveBg').style.width = width + 'px';
        } else if (width > dragData.maxwidth) {
            document.getElementsByClassName('moveDiv')[0].style.left = dragData.maxwidth + 'px';
            document.getElementById('moveBg').style.width = dragData.maxwidth + 'px';
            dragData.mouseMoveStata = false
            dragData.confirmSuccess = true
            dragData.message = getLangValue('login.message3')
        }
    }
}



const moseUpFn = (e) => {
    dragData.mouseMoveStata = false;
    if (!dragData.confirmSuccess) {
        var width = e.clientX - dragData.beginClientX;
        if (width < dragData.maxwidth) {
            document.getElementsByClassName('moveDiv')[0].style.left = 0 + 'px';
            document.getElementById('moveBg').style.width = 0 + 'px';
            dragData.confirmSuccess = false
        }
    }

};

/** 
 * 拖动验证部分
 */
onMounted(() => {
    if (showIndex.value == 0)
        initBar()
})
onUnmounted(() => {
    // 销毁监听移动
    document.removeEventListener('mousemove',mouseMoveFn);
    // 销毁监听手指离开事件
    document.removeEventListener('mouseup',moseUpFn)
})
</script>

<template>
    <div class="auth-page-wrapper pt-5">
        <div class="auth-one-bg-position auth-two-bg" id="auth-particles" style="height: 380px;">
            <div class="bg-overlay"></div>
            <div class="shape">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 1440 120">
                    <path fill="#f3f3f9"
                        d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z">
                    </path>
                </svg>
            </div>
        </div>

        <div class="auth-page-content">
            <b-container>
                <div class="col-12 logo-box " style="margin-top: 70px;">
                    <div class="text-center text-white-50">
                        <!-- <img :src="logoImg" alt="" style="height: 128px" /> -->
                        <!-- <p style="font-size: 24px;" class="login-logo mb-0" v-if="Env == 'en'">
                            Start your digital transformation journey
                        </p> -->
                        <p style="font-size: 24px;" class="login-logo mb-0">{{ getLangValue('login.helloWord') }}</p>
                    </div>
                </div>

                <b-row class="justify-content-center">
                    <b-col md="8" lg="6" xl="5">
                        <b-card no-body class="mt-4">
                            <b-card-body class="p-4">
                                <div class="text-r mt-2 d-flex justify-content-between "
                                    style="color: #405189; text-align: right;">
                                    <div>
                                        <span>{{ formData.title }}</span>
                                    </div>
                                    <div>
                                        <span @click="chineseClick">{{ getLangValue('login.chinese') }}</span> | <span
                                            @click="englishClick">{{ getLangValue('login.english') }}</span>
                                    </div>
                                </div>
                                <div class="text-center py-4"
                                    style="font-size: 20px; font-weight: bold; color: #212529;"
                                    v-show="showIndex == 0 || showIndex == 1 || showIndex == 2">
                                    {{ getLangValue('login.title') }}
                                </div>
                                <div class="p-2 mt-4" v-if="showIndex == 0">
                                    <form>
                                        <div class="mb-3 my-4">
                                            <label for="email" class="form-label">{{ getLangValue('login.newEmail')
                                                }}<span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="email" v-model="formData.email"
                                                :class="[(isCheckForm && !formData.email) && 'is-invalid']"
                                                :placeholder="getLangValue('login.message1')">
                                        </div>
                                        <div class="mb-3" style="margin: 60px 0 140px 0 !important;">
                                            <div style="height: 38px; border: 1px solid #CED4DA;border-radius: 0.25rem; position: relative; text-align: center; line-height: 38px;user-select: none;"
                                                ref="dragDiv">
                                                <div @mousedown="mousedownFn($event)"
                                                    class="moveDiv d-flex align-items-center justify-content-center"
                                                    style="height: 36px; background-color: #cfd4d9; width: 62px; position: absolute;left:0; cursor: move; border-radius: 0 0.25rem  0.25rem 0;z-index: 2;"
                                                    ref="moveDiv">
                                                    <i style="font-size: 20px;" class="ri-arrow-right-s-line"></i>
                                                    <i style="font-size: 20px; margin-left: -10px;"
                                                        class="ri-arrow-right-s-line"></i>
                                                </div>
                                                <div v-if="!dragData.mouseMoveStata"
                                                    style="color: #888a98;position: absolute;text-align: center;margin: 0 auto; width: 100%; z-index: 1;">
                                                    {{ dragData.message }}</div>
                                                <div v-if="dragData.mouseMoveStata"
                                                    style="color: white;position: absolute;text-align: center;margin: 0 auto; width: 100%; z-index: 1;">
                                                    {{ dragData.message }}</div>
                                                <div v-if="dragData.confirmSuccess"
                                                    style="color: white;position: absolute;text-align: center;margin: 0 auto; width: 100%; z-index: 1;">
                                                    {{ dragData.message }}</div>
                                                <div id="moveBg"
                                                    style="position: absolute; background-color: #51b09d;height: 36px; left: 0; top: 0;border-radius:0.19rem 0 0 0.19rem">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="mt-4" style="margin-bottom: 50px;">
                                            <b-button variant="success" class="w-100" @click="switchCotent">
                                                {{ getLangValue('login.next') }}
                                            </b-button>
                                        </div>
                                    </form>
                                </div>
                                <div class="p-2 mt-4" v-if="showIndex == 1">
                                    <form>
                                        <div class="mb-3" style="width: 96px; margin: 90px auto;">
                                            <img :src="completeSvg" width="96" />
                                        </div>
                                        <div style="text-align: center; margin: 20px 0 180px 0;">
                                            {{ formData.message1 }}
                                        </div>
                                        <div class="mt-4" style="margin-bottom: 50px;">
                                            <b-button variant="success" class="w-100" @click="goLogin">
                                                {{ getLangValue('login.confirm') }}
                                            </b-button>
                                        </div>
                                    </form>
                                </div>

                                <div class="p-2 mt-4" v-if="showIndex == 2">
                                    <form>
                                        <div class="mb-4">
                                            <label for="email" class="form-label">{{ getLangValue('login.newEmail')
                                                }}<span class="text-danger">*</span></label>
                                            <input v-model="formData.email" type="text" class="form-control"
                                                :class="[(isCheckForm && !formData.email) && 'is-invalid']" id="email"
                                                :placeholder="getLangValue('login.enter') + getLangValue('login.newEmail')">
                                        </div>
                                        <div class="mb-4">
                                            <label class="form-label" for="password-input">{{ getLangValue('login.password')
                                                }}<span class="text-danger">*</span></label>
                                            <div class="position-relative auth-pass-inputgroup mb-3">
                                                <input type="password" class="form-control pe-5"
                                                    v-model="formData.password"
                                                    :class="[(isCheckForm && !formData.password) && 'is-invalid']"
                                                    :placeholder="getLangValue('login.message14')" id="password-input">
                                                <b-button variant="link" @click="switchPassword(0)"
                                                    class="position-absolute end-0 top-0 text-decoration-none text-muted"
                                                    type="button" id="password-addon"><i
                                                        class="ri-eye-fill align-middle"></i></b-button>
                                            </div>
                                        </div>
                                        <div class="mb-4">
                                            <label class="form-label" for="password-input1">{{
                                                getLangValue('login.check_password')
                                            }}<span class="text-danger">*</span></label>
                                            <div class="position-relative auth-pass-inputgroup mb-3">
                                                <input type="password" class="form-control pe-5"
                                                    v-model="formData.confirmPassword"
                                                    :class="[(isCheckForm && !formData.confirmPassword) && 'is-invalid']"
                                                    :placeholder="getLangValue('login.enter') + getLangValue('login.check_password')"
                                                    id="password-input1">
                                                <b-button variant="link" @click="switchPassword(1)"
                                                    class="position-absolute end-0 top-0 text-decoration-none text-muted"
                                                    type="button" id="password-addon1">
                                                    <i class="ri-eye-fill align-middle"></i>
                                                </b-button>
                                            </div>
                                        </div>
                                        <!-- 
                                        <div class="form-check my-4">
                                            <input class="form-check-input" type="checkbox" value=""
                                                v-model="formData.confimInfo" id="auth-remember-check">
                                            <label class="form-check-label" @click="showInfo">
                                                {{ getLangValue('login.message5') }}
                                                <span style="color: #0AB39C;">{{ getLangValue('login.message6') }}</span>
                                            </label>
                                        </div> -->

                                        <div class="mt-4 mb-3">
                                            <b-button variant="success" class="w-100" @click="register">{{
                                                getLangValue('login.confirm')
                                            }}</b-button>
                                        </div>
                                    </form>
                                </div>
                            </b-card-body>
                        </b-card>



                    </b-col>
                </b-row>
            </b-container>
        </div>

        <footer class="footer">
            <b-container>
                <b-row>
                    <b-col lg="12">
                        <div class="text-center">
                            <div v-if="FILINGNUMBER"><a class="mb-0 text-muted" :href="FILINGURL" target="_blank">{{FILINGNUMBER}}</a></div>
                            <p class="mb-0 text-muted">© 2024 Powered by<i class="mdi mdi-heart text-danger"></i>Digital
                                Clothing</p>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </footer>
    </div>
</template>
<style scoped lang="scss">
/* .login {
    height: 100vh;
    background-image: url('../../assets/images/login/bg.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
} */
.auth-two-bg {
    background-image: url('../../assets/images/auth-one-bg.jpg');
    background-position: center;
    background-size: cover;

    .bg-overlay {
        background: -webkit-gradient(linear, left top, right top, from(#364574), to(#405189));
        background: linear-gradient(to right, #364574, #405189);
        opacity: .9;
    }
}

.shape {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    pointer-events: none;
}

.is-invalid {
    background-image: unset;
}
</style>
